import { CancelablePromise } from './openapi';

interface ApiError extends Error {
  status?: number;
}

export const call_backend_api = async (
  promise: CancelablePromise<any>,
  successHandler: Function | undefined = undefined,
  errorHandler: Function | undefined = undefined,
  finallyHandler: Function | undefined = undefined
) => {
  try {
    const res = await promise;
    if (successHandler) {
      successHandler(res);
    }
  } catch (err: unknown) {
    console.log('API Error:', err);
    // Check if it's a 401 error
    if (err && typeof err === 'object' && 'status' in err && (err as ApiError).status === 401) {
      // Prevent SuperTokens retry logic by throwing a custom error
      const unauthorizedError: ApiError = new Error('Unauthorized');
      unauthorizedError.status = 401;
      if (errorHandler) {
        errorHandler(unauthorizedError);
      }
      // Redirect to login page
      window.location.href = '/auth';
      return;
    }

    if (errorHandler) {
      errorHandler(err);
    }
  } finally {
    if (finallyHandler) {
      finallyHandler();
    }
  }
};
